"use client";
import React, { useEffect, useState } from "react";

// Utils
import classnames from "classnames";
import styles from "./SearchArticles.module.scss";
import type { SearchArticlesProps } from "./interface";

// Helpers
import search from "../../utils/search";
import DOMPurify from "@/app/[lang]/utils/dompurify";
import { useSearchParams } from "next/navigation";
import { getArticlesByCategory } from "../../utils/api";

// Components
import Button from "../ui/Button";
import Pagination from "../Pagination";
import { Flex, Title } from "@/app/[lang]/components/ui/AntdLite";
import Article from "@/app/[lang]/components/Article";



const PAGE_SIZE = 9;

const SearchArticles = ({
  listingPage,
  title,
  buttonText,
  onClick,
  category,
}: SearchArticlesProps) => {
  const searchParams = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [parsedResults, setParsedResults] = useState<any>({});

  useEffect(() => {
    if (category) {
      getArticlesByCategory(category).then((data) => {
        setParsedResults({
          total: data.length,
          articles: {
            ...data,
          },
        });
      });

      return;
    }

    const query = searchParams.get("query");

    if (query) {
      search(query, "articles", currentPage, PAGE_SIZE)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setParsedResults({
            total: data.articles?.meta?.pagination?.total || 0,
            ...data,
          });
        });
    }
  }, [searchParams, currentPage, category]);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return parsedResults.articles && parsedResults.articles?.data?.length > 0 ? (
    <section
      className={classnames(styles.wrapper, listingPage && styles.listingPage, 'bg-white', 'text-dark-blue')}
    >
      <div className="container">
        <Title level={2} className={ styles.title }>
          <span
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
          />
        </Title>

        <Flex className={styles.articles} gap="24px" wrap="wrap">
          {parsedResults.articles.data.map((article: any) => (
            <Article
              key={article.id}
              article={listingPage ? article : { attributes: { ...article } }}
            />
          ))}
        </Flex>

        {!onClick && parsedResults.total > PAGE_SIZE && (
          <Pagination
            defaultCurrent={currentPage}
            total={parsedResults.total}
            pageSize={PAGE_SIZE}
            onChange={handlePageChange}
          />
        )}

        {onClick && parsedResults.total > PAGE_SIZE && (
          <Flex justify="flex-end">
            <Button
              attributes={{
                type: "outline",
                backgroundColor: "black",
                textColor: "black",
                hoverColor: "light-blue",
              }}
              onClick={onClick}
            >
              {buttonText}
            </Button>
          </Flex>
        )}
      </div>
    </section>
  ) : (
    <p>...</p>
  );
};

export default SearchArticles;
